<div class="input-control-wp">
  <!-- MIGRATION: [maskInput]="'00/00/0000'"-->
  <input
    #input
    matInput
    [matDatepicker]="picker"
    [autocomplete]="false"
    [ngClass]="{ 'input-error': hasError }"
    [type]="inputType"
    (dateChange)="addEventChange($event)"
    [value]="value"
    (input)="onInput($event)"
    [placeholder]="placeholder"
    [disabled]="isDisabled"
    [readOnly]="edit"
    (blur)="onTouched($event)"
    (focus)="onFocus()"
  />

  <mat-datepicker-toggle matSuffix [for]="picker">
    <mat-icon
      class="datepicker-icon"
      matDatepickerToggleIcon
      [svgIcon]="iconName"
      [ngStyle]="{
        color: iconColor,
        width: iconSize + 'px',
        height: iconSize + 'px',
      }"
    ></mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</div>
